<div class="organization-modal" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="orgYearEndEditForm">
      <div class="field-validation-error"></div>
      <div class="row">
        <div class="col-sm-5">
          <div class="form-group required" aria-required="true">
            <label class="font-text">Organization year ends on</label>
            <div class="row">
              <div class="col-xs-12 col-12 col-md-12 form-group mb-3">
                <input
                  type="text"
                  placeholder="Select Month"
                  class="selectinput"
                  [bsConfig]="{ dateInputFormat: 'MMMM', isAnimated: true }"
                  (onShown)="onOpenCalendar($event)"
                  [(ngModel)]="date"
                  (bsValueChange)="onValueChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  bsDatepicker
                />
              </div>
              <div *ngIf="submitted && !this.organizationYearEndDate" class="input-error">
                Organization end Month is required.
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light cancel-btn modelBtn" (click)="onClose()">
      Cancel
    </button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
